class SectionVideoSignUp implements ng.IComponentController {
    ltTitle: string;
    description: string;
    logo: boolean;
    image: anm.BaseImage;
    video: anm.LandingVideo;
    background: anm.LandingBackground;
    isScrollButton: boolean;

    constructor(private $stateParams: ng.ui.IStateParamsService) {
        this.ltTitle     = this.$stateParams.t || this.ltTitle;
        this.description = this.$stateParams.d || this.description;
        this.logo        = _.isBoolean(this.logo) ? this.logo : true;
    }
}

angular.module('animatronApp.sectionVideoSignUp', []).component('sectionVideoSignUp', {
    bindings: {
        logo: '<',
        ltTitle: '<',
        description: '<',
        background: '<',
        image: '<',
        video: '<',
        isScrollButton: '<'
    },
    controller: SectionVideoSignUp,
    templateUrl: require('landing-template/components/sections/section-video-sign-up.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/sections/SectionVideoSignUp.ts